import React, { useMemo, useEffect, useState, useRef } from "react";
import "./index.less";
import {
  AuthingButton,
  AuthingButtonArrow,
} from "../../../../components/AuthingButton";
import { useTranslation } from "react-i18next";

export const KeycloakMarquee = () => {
  const { t } = useTranslation();
  const swiper2Ref = useRef();
  useEffect(() => {
    const swiper1 = new Swiper(".swiper1", {
      direction: "vertical",
      loop: true,
    });
    swiper2Ref.current = new Swiper("#swiper2", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      direction: "vertical",
      scrollbar: {
        el: ".swiper-scrollbar",
        clickable: true,
      },
      loop: true,
      autoplay: true,
    });
    swiper1.controller.control = swiper2Ref.current; //Swiper2控制Swiper1，需要初始化Swiper1之后
    swiper2Ref.current.controller.control = swiper1; //Swiper1控制Swiper2，需要初始化Swiper2之后
  }, []);
  const list = useMemo(() => {
    return [
      {
        title1: t("solution.keycloak.marquee.item1.title1"),
        desc1: t("solution.keycloak.marquee.item1.desc1"),
        title2: t("solution.keycloak.marquee.item1.title2"),
        desc2: t("solution.keycloak.marquee.item1.desc2"),
        imgUrl: "https://files.authing.co/authing-website/okta-marquee-1.png",
      },
      {
        title1: t("solution.keycloak.marquee.item2.title1"),
        desc1: t("solution.keycloak.marquee.item2.desc1"),
        title2: t("solution.keycloak.marquee.item2.title2"),
        desc2: t("solution.keycloak.marquee.item2.desc2"),
        imgUrl: "https://files.authing.co/authing-website/finance-marquee1.png",
      },
    ];
  }, [t]);
  return (
    <div className="okta-marquee">
      <div className="basic-column">
        <div className="okta-marquee-content basic-column flex">
          <div className="swiper swiper1" id="swiper1">
            <div className="swiper-wrapper">
              {list.map((item, index) => {
                return (
                  <div className="swiper-slide" key={`item-${index}`}>
                    <div className="swiper-slide-inner">
                      <div className="title1">{item.title1}</div>
                      <div className="blue-line"></div>
                      <div className="desc1">{item.desc1}</div>
                      <div className="title2  pc-show">{item.title2}</div>
                      <div className="desc2  pc-show">{item.desc2}</div>
                      <div
                        className="pad-show mobile-show"
                        style={{ height: 24 }}
                      ></div>
                      <div>
                        <AuthingButton
                          size="small"
                          style={{ marginRight: 16 }}
                          onClick={() => {
                            if (item.fromTag) {
                              window.open(
                                `/authingform?from=manufacturing&fromTag=${
                                  item.fromTag
                                }&download=${encodeURI(item.downUrl)}`
                              );
                            } else if (item.hasSolution) {
                              window.open(item.hasSolution);
                            } else {
                              window.open(`https://www.authing.cn/customer`);
                            }
                          }}
                        >
                          {item.hasSolution
                            ? t("common.button.detail")
                            : t("common.nav.learn-more")}
                        </AuthingButton>
                        {/* <AuthingButtonArrow
                          mode="color-blue"
                          onClick={() => {
                            window.open(
                              "https://www.authing.cn/authingform?fromTag=Okta预约咨询"
                            );
                          }}
                        >
                          {t("common.button.consult")}
                        </AuthingButtonArrow> */}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div style={{ flex: 24 }}></div>
          <div className="swiper swiper2" id="swiper2">
            <div className="swiper-wrapper">
              {list.map((item, index) => {
                return (
                  <div className="swiper-slide" key={`item-${index}`}>
                    <div
                      style={{
                        background: `url(${item.imgUrl}) center center no-repeat`,
                        backgroundSize: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                    ></div>
                  </div>
                );
              })}
            </div>
            <div className="swiper-scrollbar swiper2-scrollbar"></div>
            <div className="swiper2-scrollbar-top">01</div>
            <div className="swiper2-scrollbar-bottom">02</div>
            <div className="swiper-button-prev swiper2-button-prev swiper2-button">
              <i className="icon authing-icon authing-arrow-left-s-line"></i>
            </div>
            <div className="swiper-button-next swiper2-button-next swiper2-button">
              <i className="icon authing-icon authing-arrow-right-s-line"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
